import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { BsCurrencyRupee } from "react-icons/bs";
import { Link, useParams } from 'react-router-dom';
import { useState } from 'react';
import axiosInterceptor from '../function/axiosInterceptor'
import axios from 'axios';
const DonateUser_dt = () => {
    const  navigator  = useNavigate()
    const { id } = useParams()
    const [data, setData] = useState({ name: '', dob: '', phone: '', email: '', country: 'India', state: '', city: '', postoffice: '', address: '', pin: '', amount: id, pan: '', transactionNo: '', maxDob: new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate()) })
    const onInputValue = (event) => {
        const target = event.currentTarget;
        setData((prev) => ({ ...prev, [target.name]: target.value }))
    }
    const getLocation = async () => {
        try {
            if (data.pin && data.pin.length !== 6) {
                toast.warn('Invalid pincode...!!', { position: 'top-center', autoClose: 700 }); return
            }
            const response = await axios.get(`https://hostguardians.com/api/location/pincode/${data.pin}`);
            if (response?.data?.status === 1) {
                setData((prev) => ({ ...prev, state: response.data.state, city: response.data.district }))
            } else {
                toast.warn('Invalid pincode...!!', { position: 'top-center', autoClose: 700 })
            }
        } catch (err) { toast.error(err.message, { position: 'top-center', autoClose: 700 }) }
    }
    const SubmitForm = async (event) => {
        event.preventDefault();
        if (data.name == '') {
            toast.warn("Plase enter your " + data.name + " ...!!");
            return;
        }
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(data.email)) {
            toast.warn("Please enter valid Email..!!");
            return;
        }
        if (!/^\(?([6-9]{1})\)?([0-9]{9})$/.test(data.phone)) {
            toast.warn("Please enter valid phone no..!!");
            return;
        }
        if (data.pan == '') {
            toast.warn("Please enter pan number..!!");
            return;
        } else {
            if (data.pan.length != 10 && !/[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(data.pan)) {
                toast.warn("Please enter valid pan number..!!");
                return;
            }
        }
        try {
            const response = await axiosInterceptor.post('/donate', data)
            if (response.status === 'success') {
                navigator(`/donation/thanks/${response?.data}`)
                toast.success(response.message, { autoClose: 700, position: 'top-center' })
            } else {
                toast.warn(response.message, { autoClose: 700, position: 'top-center' })
            }
        } catch (err) {
            toast.error(err.message, { position: 'top-center', autoClose: 700 })
        }
    }
    return (<>,
        <ToastContainer />
        <div className="breadcrumb-area" style={{ backgroundImage: "url(https://api.mnbfoundation.com/img/7122023_8486631.jpg)" }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="breadcrumb-inner">
                            <div className="icon">
                                <img src="/main/files/static/green-hart.png" />
                            </div>
                            <h2 className="page-title">Donation</h2>
                            <ul className="page-list">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="#">Donation </Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className='hght'>
                    </div>
                </div>
            </div>
        </div>
        <div className='form-sect'>
            <div className='w-100'>
                <div className="container">
                    <div className="row dnt-row">
                        <div className="col-4 section-title cls d-col">
                            <div className='formimg'>
                                <img src="/main/files/static/donatepage.jpg" />
                                <div className='imctext'>Your donation will support skill training and healthcare for marginalized women</div>
                            </div>
                            <img src="/main/files/static/qr.png" width={270} className='mt-3' />
                        </div>
                        <div className="col-8 d-col">
                            <div className='donte-amt'><BsCurrencyRupee/>{data.amount}</div>



                            <form class="row g-2 donates" onSubmit={SubmitForm}>
                                <div class="col-md-12">
                                    <label htmlFor="name" class="form-label mb-0">Name <code>*</code></label>
                                    <input type="name" class="form-control" id="name" name="name" placeholder='xyz' value={data.name} onInput={onInputValue} required />
                                </div>
                                <div class="col-md-6">
                                    <label htmlFor="email" class="form-label mb-0">Email <code>*</code></label>
                                    <div class="input-group">
                                        <span class="input-group-text" id="email">@</span>
                                        <input type="email" class="form-control" placeholder="example@gmail.com" id="email" name='email' value={data.email} onChange={onInputValue} required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label htmlFor="phone" class="form-label mb-0">Phone <code>*</code></label>
                                    <div class="input-group">
                                        <span class="input-group-text" id="phone">+91</span>
                                        <input type="number" class="form-control" placeholder="9876543210" id="phone" name='phone' value={data.phone} onChange={onInputValue} required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label htmlFor="country" class="form-label mb-0">Country <code>*</code></label>
                                    <select class="form-select" name='country' id="country" value={data.country} onChange={onInputValue} required >
                                        <option>India</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label htmlFor="pin" class="form-label mb-0">Pincode <code>*</code></label>
                                    <input type="number" class="form-control" placeholder="110011" id="pin" name='pin' value={data.pin} onChange={onInputValue} onBlur={getLocation} required />
                                </div>
                                <div class="col-md-6">
                                    <label htmlFor="state" class="form-label mb-0">State <code>*</code></label>
                                    <input type="text" class="form-control" placeholder="state" id="state" name='state' value={data.state} disabled />
                                </div>
                                <div class="col-md-6">
                                    <label htmlFor="city" class="form-label mb-0">City <code>*</code></label>
                                    <input type="text" class="form-control" placeholder="city" id="city" name='city' value={data.city} disabled />
                                </div>
                                <div class="col-md-12">
                                    <label htmlFor="address" class="form-label mb-0">Address <code>*</code></label>
                                    <input type="text" class="form-control" placeholder="address" id="address" name='address' value={data.address} onChange={onInputValue} required />
                                </div>
                                <div class="col-md-6">
                                    <label htmlFor="pan" class="form-label mb-0">Pan Number<code>*</code></label>
                                    <input type="text" class="form-control" placeholder="pan" id="pan" name='pan' value={data.pan} onChange={onInputValue} required />
                                </div>
                                <div class="col-md-6">
                                    <label htmlFor="transactionNo" class="form-label mb-0">UTR Number<code>*</code></label>
                                    <input type="text" class="form-control" placeholder="transaction no" id="transactionNo" name='transactionNo' value={data.transactionNo} onChange={onInputValue} required />
                                </div>

                                <div class="col-12">
                                    <button type="submit" class="btn btn-primary">Continue</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>)
}
export default DonateUser_dt;

